import axiosInstance from './https';

export async function fireApi({
  endpoint,
  method = 'get',
  payload = null,
  extraHeaders = {},
  params = {},
  config = {}, // 👈 opt-in config
  skipAuth = false
}) {
  try {
    const headers = {
      'Content-Type': 'application/json',
      ...extraHeaders
    };

    const response = await axiosInstance.request({
      url: endpoint,
      method,
      headers,
      params,
      data: payload,
      skipAuth,
      ...config // 👈 responseType injected only when needed
    });

    const contentType = response.headers?.['content-type'] || '';

    /* =====================================================
       🔹 FILE DOWNLOADS (SAFE + CORRUPTION-FREE)
       ===================================================== */
    if (
      config?.responseType === 'blob' || // 👈 explicit opt-in
      response.data instanceof Blob // 👈 already binary
    ) {
      // 🔹 Check if it is actually a JSON error response returned as a Blob (even with status 200)
      const isJson =
        contentType.includes('application/json') ||
        (response.data instanceof Blob && response.data.type?.includes('json'));

      if (isJson && response.data instanceof Blob) {
        try {
          const text = await response.data.text();
          const parsed = JSON.parse(text);
          if (parsed?.status === 'error' || parsed?.message || parsed?.msg) {
            return {
              success: false,
              message: parsed?.message || parsed?.msg || 'Failed to download file',
              description: parsed?.description,
              error: parsed?.message || parsed?.msg || 'Failed to download file',
              endpoint
            };
          }
        } catch (e) {
          console.warn('Failed to parse error blob as JSON', e);
        }
      }

      return {
        success: true,
        data: response.data
      };
    }

    /* =====================================================
       🔹 JSON RESPONSES (UNCHANGED)
       ===================================================== */
    if (contentType.includes('application/json')) {
      if (response.data?.status === 'error') {
        return {
          success: false,
          message: response?.data?.message || response?.data?.msg || false,
          error: response?.data?.message || 'Server not responding',
          endpoint
        };
      }
      return { success: true, data: response.data };
    }

    /* =====================================================
       🔹 FALLBACK (LEGACY SUPPORT)
       ===================================================== */
    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 403) {
      setTimeout(() => {
        sessionStorage.clear();
      }, 5000);
    }

    let apiMessage = error?.message || 'Server not responding';
    let apiDescription = error?.response?.data?.description;

    // 🔹 If error response is a Blob (happens when responseType is 'blob'), read and parse it to get the JSON error message
    if (error?.response?.data instanceof Blob) {
      try {
        const text = await error.response.data.text();
        const parsed = JSON.parse(text);
        apiMessage = parsed?.errors?.[0]?.message || parsed?.message || parsed?.msg || apiMessage;
        apiDescription = parsed?.description || apiDescription;
      } catch (e) {
        console.warn('Failed to parse error blob as JSON', e);
      }
    } else {
      apiMessage =
        error?.response?.data?.errors?.[0]?.message || // 🔹 validation errors
        error?.response?.data?.message || // 🔹 normal message
        error?.response?.data?.msg || // 🔹 alternate
        apiMessage;
    }

    return {
      success: false,
      message: apiMessage,
      description: apiDescription,
      error: apiMessage,
      endpoint
    };
  }
}
